import { gql } from '@apollo/client';

const GET_CHECK_POINT_CONSTRAINTS = gql`
  query GetCheckpointConstraints($orgUnitId: Int!, $appraisalId: Int!) {
    checkpointConstraints(orgUnitId: $orgUnitId, appraisalId: $appraisalId) {
      MinDate
      MaxDate
      AllowedFileUploadSize
    }
  }
`;

export default GET_CHECK_POINT_CONSTRAINTS;
